import { JsonObject, JsonProperty } from 'typescript-json-serializer';

@JsonObject()
export class SmartmeMeter {
  @JsonProperty('Id') id: string;
  @JsonProperty('Name') name: string;
}
